import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["ordered", "children"];
import React from 'react';
import styled from 'styled-components';
import styles from './List.style';
import { any } from 'prop-types';
var Ol = styled.ol.withConfig({
  componentId: "sc-w7248b-0"
})(["", ""], styles);
var Ul = styled.ul.withConfig({
  componentId: "sc-w7248b-1"
})(["", " list-style-type:none;"], styles);
var List = function List(_ref) {
  var ordered = _ref.ordered,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ordered ? Ol : Ul, props, children);
};
List.defaultProps = {
  ordered: false,
  children: any
};
export default styled(List).withConfig({
  componentId: "sc-w7248b-2"
})(["", ";"], styles);
export { List as ListVanilla };